import React from 'react';
import Header from '../components/Header';
import Integrations from '../components/Integrations';
import Footer from '../components/Footer';

function IntegrationsPage() {
  return (
    <>
      <Header />
      <main>
        <Integrations />
      </main>
      <Footer />
    </>
  );
}

export default IntegrationsPage;
